<template>
  <div class="row">
    <h5 class="col-12 h2 mb-0 mt-4 mb-2">Painel Geral </h5>
    <h5 class="col-12 card-title text-uppercase text-muted mb-2 h5">Score, Rating e limite</h5>
    <div class="row col-7 mt-3">
      <div class="card-deck col-12">
        <card style="max-height: 60vh">
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h5 class="h3 mb-0">SCORE</h5>
            </div>
          </div>
          <div class="col-4" style="position: absolute; bottom: 20%; right: 50%; transform: translateX(50%); border-radius: 9px; background-color: #5e72e4; padding: 10px;">
            <p class="text-center" style="font-weight: 900; font-size: 18px; color: white;  margin: 0">
              Rating atual: {{ redBarChart.chartData.labels[0] }}
            </p>
          </div>

          <div class="d-flex col-12">
            <score-chart :score="this.score" :max-value="100" style="height: 45vh; width: 60vw; position: relative'"/>
          </div>
        </card>
      </div>
      <div class="card-deck col-12">
        <card class="col-12" style="max-height: 35vh">
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h5 class="h3 mb-0">RATING</h5>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <bar-chart style="height: 20vh; width: 50vw;" :chart-data="redBarChart.chartData" />
          </div>
        </card>
      </div>
      <!-- <base-button icon type="secundary" class="ml-3 mb-3">
        <span class="btn-inner--icon">
          <i class="ni ni-bullet-list-67"></i>
        </span>
        <span class="btn-inner--text">Histórico de Score, Rating e Limites</span>
      </base-button> -->
    </div>
    <div class="card-deck col-5 ml-1 d-flex flex-row-reverse bd-highlight">
      <limits :client_id="client_id"/>
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/Charts/BarChart"
import ScoreChart from "@/components/Charts/ScoreChart"
import Limits from './Limits.vue'

export default {
  name: 'score-rating',
  components: { 
    BarChart,
    ScoreChart,
    Limits
  },
  props: {
    score: {
      default: () => 0
    },
    client_id: {
      type: Number
    },
    keyScore: {
      type: Number
    }
  },
  data() {
    return {
      redBarChart: {
        chartData: {
          labels: ["Carregando..."],
          datasets: [
            {
              label: "Rating",
              data: [0],
            },
          ],
        },
      },
      ratings: []
    }
  },
  mounted() {
    this.getRating()
  },
  methods: {
    async getRating() {
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_references")
      this.ratings = response.data
      let filteredRating = this.ratings.filter(rating => rating.minimum_score <= this.score).sort((a, b) => {
        const order = { '+': -1, '-': 1, undefined: 0 };
        return a.rating[0].localeCompare(b.rating[0]) || order[a.rating[1]] - order[b.rating[1]];
      });

      this.redBarChart =  {
        chartData: {
          labels: filteredRating.map(rating=> rating.rating),
          datasets: [
            {
              label: "Rating Mínimo",
              data: filteredRating.map(rating => rating.minimum_score)
            },
          ],
        },
      }
    }
  },
  watch: {
    keyScore(value) {
      this.getRating()
    }
  }
}
</script>

<style>

</style>